export const getCloseIconClasses = (isActiveTab: boolean) =>
  isActiveTab
    ? '[&>svg]:fill-[var(--ds-inner-tab-active-close-bg)] hover:[&>svg]:fill-[var(--ds-inner-tab-active-hover-close-bg)]'
    : '[&>svg]:fill-[var(--ds-inner-tab-inactive-close-bg)] hover:[&>svg]:fill-[var(--ds-inner-tab-inactive-hover-close-bg)]';
